import { ViewIcon } from "@chakra-ui/icons"
import {
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/react"
import { useState } from "react"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "next-i18next"

const PasswordInput = ({
  name,
  required,
  ...props
}: { name: string; required?: boolean } & InputProps) => {
  const { t } = useTranslation()
  const [show, setShow] = useState(false)
  const handleClick = () => setShow(!show)

  const { register } = useFormContext()

  return (
    <InputGroup>
      <Input
        type={show ? "text" : "password"}
        placeholder={t("auth.password_label")}
        _placeholder={{ base : {fontSize: "sm"}, sm: {fontSize: "md"} }}
        required={required}
        {...register(name)}
        {...props}
      />
      <InputRightElement>
        <IconButton
          variant="ghost"
          size="sm"
          onClick={handleClick}
          aria-label={t("auth.password_label")}
          icon={<ViewIcon />}
        />
      </InputRightElement>
    </InputGroup>
  )
}

export default PasswordInput
